function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var saito = require('../../lib/saito/saito');
var ModTemplate = require('../../lib/templates/modtemplate');
var SaitoHeader = require('../../lib/saito/ui/saito-header/saito-header');
var Transaction = require('../../lib/saito/transaction')["default"];
var AddAppOverlay = require('./lib/overlay/add-app');
var GenerateAppOverlay = require('./lib/overlay/generate-app');
var DevTools = /*#__PURE__*/function (_ModTemplate) {
  function DevTools(app) {
    var _this;
    _classCallCheck(this, DevTools);
    _this = _callSuper(this, DevTools, [app]);
    _this.app = app;
    _this.name = 'DevTools';
    _this.appname = 'DevTools';
    _this.slug = 'devtools';
    _this.description = 'Application manages installing, indexing, compiling and serving Saito modules.';
    _this.categories = 'Utilities Dev';
    _this.featured_apps = [];
    _this.header = null;
    _this.icon = 'fas fa-window-restore';
    _this.bundling_timer = null;
    _this.renderMode = 'none';
    _this.search_options = {};
    _this.styles = ['/saito/saito.css', '/devtools/style.css'];
    _this.addAppOverlay = null;
    _this.zip_file = null;
    _this.title = null;
    _this.description = null;
    _this.status = 'prod';
    _this["class"] = 'utility';
    _this.app_slug = null;
    _this.version = null;
    _this.publisher = null;
    _this.category = null;
    _this.img = null;
    _this.generate_app = null;
    return _this;
  }
  _inherits(DevTools, _ModTemplate);
  return _createClass(DevTools, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _superPropGet(DevTools, "initialize", this, 3)([app]);
            case 1:
              this.addAppOverlay = new AddAppOverlay(this.app, this);
              this.generateAppOverlay = new GenerateAppOverlay(this.app, this);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (this.app.BROWSER) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              this.header = new SaitoHeader(this.app, this);
              _context2.n = 2;
              return this.header.initialize(this.app);
            case 2:
              this.addComponent(this.header);
              _context2.n = 3;
              return _superPropGet(DevTools, "render", this, 3)([]);
            case 3:
              this.attachEvents();
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "initializeHTML",
    value: function () {
      var _initializeHTML = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app) {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _superPropGet(DevTools, "initializeHTML", this, 3)([app]);
            case 1:
              if (!(this.header == null)) {
                _context3.n = 2;
                break;
              }
              this.header = new SaitoHeader(app, this);
              _context3.n = 2;
              return this.header.initialize(app);
            case 2:
              _context3.n = 3;
              return this.header.render(app, this);
            case 3:
              this.header.attachEvents(app, this);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function initializeHTML(_x2) {
        return _initializeHTML.apply(this, arguments);
      }
      return initializeHTML;
    }()
  }, {
    key: "respondTo",
    value: function respondTo(type) {
      var this_self = this;
      if (type === 'saito-header') {
        // let x = [];
        // if (!this.browser_active) {
        // 	x.push({
        // 		text: 'Add app',
        // 		icon: 'fa-solid fa-plus',
        //		type: 'quicklaunch',
        // 		callback: function (app, id) {
        // 			this_self.addAppOverlay.render();
        // 		}
        // 	});
        // 	return x;
        // }
      }
      return null;
    }
  }, {
    key: "sendSubmitModuleTransaction",
    value: function () {
      var _sendSubmitModuleTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(zip, slug, callback) {
        var peers, msg;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.app.network.getPeers();
            case 1:
              peers = _context4.v;
              if (!(peers.length == 0)) {
                _context4.n = 2;
                break;
              }
              console.warn('No peers');
              return _context4.a(2);
            case 2:
              msg = {
                module: 'AppStore',
                request: 'submit module',
                module_zip: zip,
                slug: slug
              };
              console.log('zip_file trans', zip);
              this.app.network.sendRequestAsTransaction('submit module', msg, function (res) {
                console.log('appstore callback: ' + res);
                return callback(res);
              }, peers[0].publicKey);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function sendSubmitModuleTransaction(_x3, _x4, _x5) {
        return _sendSubmitModuleTransaction.apply(this, arguments);
      }
      return sendSubmitModuleTransaction;
    }()
  }, {
    key: "sendModuleDetailsTransaction",
    value: function () {
      var _sendModuleDetailsTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(zip, callback) {
        var peers, msg;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.app.network.getPeers();
            case 1:
              peers = _context5.v;
              if (!(peers.length == 0)) {
                _context5.n = 2;
                break;
              }
              console.warn('No peers');
              return _context5.a(2);
            case 2:
              msg = {
                module: 'AppStore',
                request: 'get module details',
                module_zip: zip
              };
              this.app.network.sendRequestAsTransaction('get module details', msg, function (res) {
                console.log('appstore callback: ' + res);
                return callback(res);
              }, peers[0].publicKey);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function sendModuleDetailsTransaction(_x6, _x7) {
        return _sendModuleDetailsTransaction.apply(this, arguments);
      }
      return sendModuleDetailsTransaction;
    }()
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(app) {
        var tx,
          peer,
          mycallback,
          this_self,
          txmsg,
          _txmsg$data,
          module_zip,
          slug,
          _txmsg$data2,
          _module_zip,
          _slug,
          _args6 = arguments;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              tx = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : null;
              peer = _args6.length > 2 ? _args6[2] : undefined;
              mycallback = _args6.length > 3 ? _args6[3] : undefined;
              this_self = this;
              if (!(tx == null)) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2, 0);
            case 1:
              txmsg = tx.returnMessage();
              if (txmsg.request) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2, 0);
            case 2:
              if (!(txmsg.request === 'submit module')) {
                _context6.n = 3;
                break;
              }
              _txmsg$data = txmsg.data, module_zip = _txmsg$data.module_zip, slug = _txmsg$data.slug;
              _context6.n = 3;
              return this_self.createAppBinary(module_zip, slug, mycallback);
            case 3:
              if (!(txmsg.request === 'get module details')) {
                _context6.n = 4;
                break;
              }
              _txmsg$data2 = txmsg.data, _module_zip = _txmsg$data2.module_zip, _slug = _txmsg$data2.slug;
              _context6.n = 4;
              return this_self.getNameAndDescriptionFromZip(_module_zip, mycallback);
            case 4:
              return _context6.a(2, _superPropGet(DevTools, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee6, this);
      }));
      function handlePeerTransaction(_x8) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "clear",
    value: function clear() {
      this.zip_file = null;
      this.title = null;
      this.description = null;
      this.app_slug = null;
      this.version = null;
      this.publisher = null;
      this.category = null;
      this.img = null;
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      try {
        if (this.app.BROWSER) {
          var this_self = this;
          this.app.browser.addDragAndDropFileUploadToElement("appstore-zip-upload", /*#__PURE__*/function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(filesrc) {
              var startPoint;
              return _regenerator().w(function (_context8) {
                while (1) switch (_context8.n) {
                  case 0:
                    this_self.clear();
                    startPoint = filesrc.indexOf('base64');
                    if (!(startPoint < 0)) {
                      _context8.n = 1;
                      break;
                    }
                    throw new Error('File not base64 zipped');
                  case 1:
                    this_self.zip_file = filesrc.substring(startPoint + 7);
                    console.log('zip_file: ', this_self.zip_file);
                    _context8.n = 2;
                    return this_self.sendModuleDetailsTransaction(this_self.zip_file, /*#__PURE__*/function () {
                      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(res) {
                        return _regenerator().w(function (_context7) {
                          while (1) switch (_context7.n) {
                            case 0:
                              console.log('mod details: ', res);
                              if (!(res.slug == '')) {
                                _context7.n = 1;
                                break;
                              }
                              salert('Error: Application missing slug');
                              return _context7.a(2);
                            case 1:
                              this_self.generateAppOverlay.mod_details = res;
                              this_self.generateAppOverlay.mod_details.publisher = this_self.publicKey;
                              this_self.generateAppOverlay.zip_file = this_self.zip_file;
                              this_self.generateAppOverlay.render();
                            case 2:
                              return _context7.a(2);
                          }
                        }, _callee7);
                      }));
                      return function (_x0) {
                        return _ref2.apply(this, arguments);
                      };
                    }());
                  case 2:
                    return _context8.a(2);
                }
              }, _callee8);
            }));
            return function (_x9) {
              return _ref.apply(this, arguments);
            };
          }(), true, false, false);
          if (document.getElementById('install')) {
            document.getElementById('install').onclick = function (e) {
              _this2.app.connection.emit('saito-app-app-render-request');
            };
          }
        }
      } catch (err) {
        console.error('Error: ', err);
        salert('An error occurred while compiling application. Check console for details.');
      }
    }
  }, {
    key: "createAppBinary",
    value: function () {
      var _createAppBinary = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(zip_bin, slug, mycallback) {
        var path, fs, _require, execSync, projectRoot, zipDir, saitoDir, tempZipPath, zipBin2, saitoPath, content, webObj, msgStr, msgObj, DYN_MOD_WEB, _t;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              path = require('path');
              fs = this.app.storage.returnFileSystem();
              _require = require('child_process'), execSync = _require.execSync;
              projectRoot = path.join(__dirname, '../..');
              zipDir = path.join(projectRoot, 'dist', 'mods', 'zip');
              saitoDir = path.join(projectRoot, 'dist', 'mods', 'saito');
              _context9.p = 1;
              if (!fs.existsSync(zipDir)) {
                fs.mkdirSync(zipDir, {
                  recursive: true
                });
              }
              tempZipPath = path.join(zipDir, ".tmp_".concat(slug, ".zip"));
              zipBin2 = Buffer.from(zip_bin, 'base64').toString('binary');
              fs.writeFileSync(tempZipPath, zipBin2, {
                encoding: 'binary'
              });
              _context9.p = 2;
              execSync("node scripts/dynmods/compile.js --zip \"".concat(tempZipPath, "\" --slug \"").concat(slug, "\""), {
                cwd: projectRoot,
                stdio: 'pipe',
                maxBuffer: 10 * 1024 * 1024
              });
              saitoPath = path.join(saitoDir, "".concat(slug, ".saito"));
              content = fs.readFileSync(saitoPath, 'utf8');
              webObj = JSON.parse(content);
              msgStr = Buffer.from(webObj.m, 'base64').toString('utf8');
              msgObj = JSON.parse(msgStr);
              DYN_MOD_WEB = msgObj.bin;
              if (!mycallback) {
                _context9.n = 3;
                break;
              }
              return _context9.a(2, mycallback({
                DYN_MOD_WEB: DYN_MOD_WEB
              }));
            case 3:
              _context9.p = 3;
              try {
                fs.unlinkSync(tempZipPath);
              } catch (e) {}
              return _context9.f(3);
            case 4:
              _context9.n = 6;
              break;
            case 5:
              _context9.p = 5;
              _t = _context9.v;
              console.log('Error in Appstore createAppBinary:', _t);
            case 6:
              return _context9.a(2);
          }
        }, _callee9, this, [[2,, 3, 4], [1, 5]]);
      }));
      function createAppBinary(_x1, _x10, _x11) {
        return _createAppBinary.apply(this, arguments);
      }
      return createAppBinary;
    }()
  }, {
    key: "getAppPath",
    value: function () {
      var _getAppPath = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(directory, slug) {
        var app_path, promises, _t2;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              _context1.p = 0;
              app_path = "".concat(slug, ".js");
              promises = directory.files.map(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(file) {
                  var file_path;
                  return _regenerator().w(function (_context0) {
                    while (1) switch (_context0.n) {
                      case 0:
                        file_path = file.path;
                        if (!(file_path == "".concat(slug, "/").concat(slug, "/"))) {
                          _context0.n = 1;
                          break;
                        }
                        app_path = "".concat(slug, "/").concat(slug, "/").concat(slug, ".js");
                        return _context0.a(2);
                      case 1:
                        if (!(file_path == "".concat(slug, "/"))) {
                          _context0.n = 2;
                          break;
                        }
                        app_path = "".concat(slug, "/").concat(slug, ".js");
                        return _context0.a(2);
                      case 2:
                        return _context0.a(2);
                    }
                  }, _callee0);
                }));
                return function (_x14) {
                  return _ref3.apply(this, arguments);
                };
              }());
              _context1.n = 1;
              return Promise.all(promises);
            case 1:
              return _context1.a(2, app_path);
            case 2:
              _context1.p = 2;
              _t2 = _context1.v;
              console.log('ERROR getAppPath: ' + _t2);
            case 3:
              return _context1.a(2);
          }
        }, _callee1, null, [[0, 2]]);
      }));
      function getAppPath(_x12, _x13) {
        return _getAppPath.apply(this, arguments);
      }
      return getAppPath;
    }()
  }, {
    key: "getNameAndDescriptionFromZip",
    value: function () {
      var _getNameAndDescriptionFromZip = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(zip_bin, mycallback) {
        var fs, path, unzipper, zip_path, zip_bin2, name, image, description, categories, slug, version, directory, promises, _t3, _t4, _t5;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              _context11.p = 0;
              fs = this.app.storage.returnFileSystem();
              path = require('path');
              unzipper = require('unzipper');
              zip_path = "app.zip"; // console.log('zip_bin:',zip_bin);
              console.log('zip_path:', zip_path);
              // return;
              //
              // convert base64 to vinary
              //
              zip_bin2 = Buffer.from(zip_bin, 'base64').toString('binary');
              fs.writeFileSync(path.resolve(__dirname, zip_path), zip_bin2, {
                encoding: 'binary'
              });
              name = 'Unknown Module';
              image = '';
              description = 'unknown';
              categories = 'unknown';
              slug = '';
              version = '1.0.0';
              _context11.p = 1;
              _context11.n = 2;
              return unzipper.Open.file(path.resolve(__dirname, zip_path));
            case 2:
              directory = _context11.v;
              promises = directory.files.map(/*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(file) {
                  var _content, _content2, content, zip_text, zip_lines, found_name, found_description, found_categories, found_slug, i, cleanString;
                  return _regenerator().w(function (_context10) {
                    while (1) switch (_context10.n) {
                      case 0:
                        cleanString = function _cleanString(str) {
                          str = str.replace(/^\s+|\s+$/gm, '');
                          str = str.substring(1, str.length - 1);
                          return _toConsumableArray(str).map(function (_char) {
                            if (_char == ' ') {
                              return ' ';
                            }
                            if (_char == '.') {
                              return '.';
                            }
                            if (_char == ',') {
                              return ',';
                            }
                            if (_char == '!') {
                              return '!';
                            }
                            if (_char == '`') {
                              return '';
                            }
                            if (_char == '\\' || _char == "'" || _char == '"' || _char == ';') {
                              return '';
                            }
                            if (!/[a-zA-Z0-9_-]/.test(_char)) {
                              return '';
                            }
                            return _char;
                          }).join('');
                        };
                        console.log('file: ', file);
                        // return;
                        if (!(file.path === 'web/img/arcade/arcade.jpg')) {
                          _context10.n = 2;
                          break;
                        }
                        _context10.n = 1;
                        return file.buffer();
                      case 1:
                        _content = _context10.v;
                        image = 'data:image/jpeg;base64,' + _content.toString('base64');
                      case 2:
                        if (!(file.path === 'web/img/saito_icon.jpg')) {
                          _context10.n = 4;
                          break;
                        }
                        _context10.n = 3;
                        return file.buffer();
                      case 3:
                        _content2 = _context10.v;
                        image = 'data:image/jpeg;base64,' + _content2.toString('base64');
                      case 4:
                        if (!(file.path.substr(0, 3) == 'lib')) {
                          _context10.n = 5;
                          break;
                        }
                        return _context10.a(2);
                      case 5:
                        if (!(file.path.substr(-2) !== 'js')) {
                          _context10.n = 6;
                          break;
                        }
                        return _context10.a(2);
                      case 6:
                        if (!(file.path.indexOf('web/') > -1)) {
                          _context10.n = 7;
                          break;
                        }
                        return _context10.a(2);
                      case 7:
                        if (!(file.path.indexOf('src/') > -1)) {
                          _context10.n = 8;
                          break;
                        }
                        return _context10.a(2);
                      case 8:
                        if (!(file.path.indexOf('www/') > -1)) {
                          _context10.n = 9;
                          break;
                        }
                        return _context10.a(2);
                      case 9:
                        if (!(file.path.indexOf('lib/') > -1)) {
                          _context10.n = 10;
                          break;
                        }
                        return _context10.a(2);
                      case 10:
                        if (!(file.path.indexOf('license/') > -1)) {
                          _context10.n = 11;
                          break;
                        }
                        return _context10.a(2);
                      case 11:
                        if (!(file.path.indexOf('docs/') > -1)) {
                          _context10.n = 12;
                          break;
                        }
                        return _context10.a(2);
                      case 12:
                        if (!(file.path.indexOf('sql/') > -1)) {
                          _context10.n = 13;
                          break;
                        }
                        return _context10.a(2);
                      case 13:
                        _context10.n = 14;
                        return file.buffer();
                      case 14:
                        content = _context10.v;
                        zip_text = content.toString('utf-8');
                        zip_lines = zip_text.split('\n');
                        found_name = 0;
                        found_description = 0;
                        found_categories = 0;
                        found_slug = 0;
                        for (i = 0; i < zip_lines.length && i < 100 && (found_name == 0 || found_description == 0 || found_categories == 0); i++) {
                          //
                          // get name
                          //
                          if (/this.name/.test(zip_lines[i]) && found_name == 0) {
                            found_name = 1;
                            if (zip_lines[i].indexOf('=') > 0) {
                              name = zip_lines[i].substring(zip_lines[i].indexOf('='));
                              name = cleanString(name);
                              name = name.replace(/^\s+|\s+$/gm, '');
                              if (name.length > 50) {
                                name = 'Unknown';
                                found_name = 0;
                              }
                              if (name === 'name') {
                                name = 'Unknown';
                                found_name = 0;
                              }
                            }
                          }

                          //
                          // get description
                          //
                          if (/this.description/.test(zip_lines[i]) && found_description == 0) {
                            found_description = 1;
                            if (zip_lines[i].indexOf('=') > 0) {
                              description = zip_lines[i].substring(zip_lines[i].indexOf('='));
                              description = cleanString(description);
                              description = description.replace(/^\s+|\s+$/gm, '');
                            }
                          }

                          //
                          // get categories
                          //
                          if (/this.categories/.test(zip_lines[i]) && found_categories == 0) {
                            found_categories = 1;
                            if (zip_lines[i].indexOf('=') > 0) {
                              categories = zip_lines[i].substring(zip_lines[i].indexOf('='));
                              categories = cleanString(categories);
                              categories = categories.replace(/^\s+|\s+$/gm, '');
                            }
                          }

                          //
                          // get slug
                          //
                          if (/this.slug/.test(zip_lines[i]) && found_slug == 0) {
                            found_slug = 1;
                            if (zip_lines[i].indexOf('=') > 0) {
                              slug = zip_lines[i].substring(zip_lines[i].indexOf('='));
                              slug = cleanString(slug);
                              slug = slug.replace(/^\s+|\s+$/gm, '');
                            }
                          }
                        }
                      case 15:
                        return _context10.a(2);
                    }
                  }, _callee10);
                }));
                return function (_x17) {
                  return _ref4.apply(this, arguments);
                };
              }());
              _context11.n = 3;
              return Promise.all(promises);
            case 3:
              _context11.n = 5;
              break;
            case 4:
              _context11.p = 4;
              _t3 = _context11.v;
              console.log('ERROR UNZIPPING: ' + _t3);
            case 5:
              _context11.p = 5;
              _context11.n = 6;
              return fs.unlink(path.resolve(__dirname, zip_path));
            case 6:
              _context11.n = 8;
              break;
            case 7:
              _context11.p = 7;
              _t4 = _context11.v;
              console.error(_t4);
            case 8:
              if (!mycallback) {
                _context11.n = 9;
                break;
              }
              return _context11.a(2, mycallback({
                name: name,
                image: image,
                description: description,
                categories: categories,
                slug: slug,
                version: version
              }));
            case 9:
              _context11.n = 11;
              break;
            case 10:
              _context11.p = 10;
              _t5 = _context11.v;
              console.log('Error in Appstore getNameAndDescriptionFromZip:', _t5);
            case 11:
              return _context11.a(2);
          }
        }, _callee11, this, [[5, 7], [1, 4], [0, 10]]);
      }));
      function getNameAndDescriptionFromZip(_x15, _x16) {
        return _getNameAndDescriptionFromZip.apply(this, arguments);
      }
      return getNameAndDescriptionFromZip;
    }()
  }, {
    key: "download",
    value: function download(content, fileName, contentType, callback) {
      var a = document.createElement('a');
      var file = new Blob([content], {
        type: contentType
      });
      a.href = URL.createObjectURL(file);
      a.download = fileName;
      a.click();
      if (callback) {
        return callback();
      }
    }
  }]);
}(ModTemplate);
module.exports = DevTools;